// extracted by mini-css-extract-plugin
export default {"badge":"PrimaryBadge_badge__2MmJG"};